import React from 'react';

import { pm } from 'lib/helpers/utility';
import { formatDate } from 'lib/helpers/dateUtils';
import { EditRoleContextProvider } from 'lib/context/Role/EditRoleContext/EditRoleContextProvider';

import Actions from '../components/Actions';

export const defaultColumns = (permissions, practiceTimezone, isAdmin, forAdmin) => [
  {
    field: 'name',
    headerName: 'Name',
    cellClass: 'no-border',
    flex: 1,
    enableRowGroup: true
  },
  {
    field: 'number_of_permissions',
    headerName: 'Permissions',
    cellClass: 'no-border',
    valueFormatter: ({ value }) => value,
    flex: 1,
    enableRowGroup: true
  },
  {
    field: 'users_assigned',
    headerName: 'Users assigned',
    cellClass: 'no-border',
    valueFormatter: ({ value }) => value,
    flex: 1,
    enableRowGroup: true
  },
  {
    field: 'description',
    headerName: 'Description',
    cellClass: 'no-border',
    flex: 2,
    enableRowGroup: true
  },
  {
    field: 'createdAt',
    headerName: 'Created at',
    cellClass: 'no-border',
    valueFormatter: ({ value }) => formatDate(value, practiceTimezone),
    flex: 1,
    enableRowGroup: true
  },
  ...(pm(
    permissions,
    forAdmin ? ['admin_role.update', 'admin_role.delete'] : ['role.update', 'role.delete'],
    'or'
  )
    ? [
        {
          field: 'actions',
          headerName: 'Actions',
          cellClass: 'no-border',
          cellRenderer: (params) => {
            if (params?.data) {
              return (
                <EditRoleContextProvider forAdmin={forAdmin}>
                  <Actions data={params?.data} isAdmin={isAdmin} forAdmin={forAdmin} />
                </EditRoleContextProvider>
              );
            }
          },
          maxWidth: 88,
          minWidth: 36,
          resizable: false,
          sortable: false,
          pinned: 'right'
        }
      ]
    : [])
];
